module.exports = __webpack_public_path__ + "static/img/4.b614d57.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/6/1/eng/4.png
// module id = opAW
// module chunks = 0